import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';
import { useNavigate, useSearch } from '@tanstack/react-router';

import { IconClose } from 'components/icons';
import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';

export const Close = () => {
  const navigate = useNavigate();
  const { eventId } = useSearch({ from: '/events' });
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title="Close" placement="top">
      <IconButton
        aria-label="close"
        data-testid="button-close"
        onClick={() => {
          if (eventId) {
            logAspenEvent({
              log_id: 'iot.web.event.interaction',
              payload: {
                event_id: eventId,
                interaction: 'close',
              },
            });
          }

          navigate({
            to: '/events',
          });
        }}
        sx={{
          alignSelf: 'center',
          '&.MuiIconButton-root': {
            padding: '0', // Override RDS padding
          },
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconClose sx={{ color: colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
